import { EmailStatusEnumType } from '__generated__/graphql';

// Single source of email-status wording, shared by posts and invites so both screens read the same.
export const emailStatusToReadable = (
  status: EmailStatusEnumType
): { label: string; color: string } => {
  switch (status) {
    case EmailStatusEnumType.Sent:
      return { label: 'Sent', color: 'gray' };
    case EmailStatusEnumType.Delivered:
      return { label: 'Delivered', color: 'gray' };
    case EmailStatusEnumType.Opened:
      return { label: 'Opened', color: 'amber' };
    case EmailStatusEnumType.Clicked:
      return {
        label: 'Clicked',
        color: 'indigo',
      };
    default:
      return { label: 'Not emailed', color: 'gray' };
  }
};
